
{
  "labels": {
    "all": "All Locations",
    "copy-id": "Copy ID",
    "copy-success": "Location ID copied to clipboard"
  }
}
